export const typeSouscripteurs = ['Personne physique', 'Personne morale'];
export const civilites = ['Monsieur', 'Madame'];
export const typesPret = [
  'Classique',
  'TauxZero',
  'InFine',
  'PretRelais',
  'PretAPaliers',
  'CreditBail'
];
export const franchisesITT = ['30', '60', '90', '120', '150', '180'];
export const typeRepriseOptions = [
  { label: 'Nouveau prêt', value: 'NouveauPret' },
  { label: 'Reprise immédiate', value: 'RepriseImmediate' },
  { label: 'Reprise à échéance anniversaire', value: 'RepriseEcheanceAnniversaire' }
];
export const origines = [
  { label: 'Lead assureur', value: 'RDV_LBC' },
  { label: 'Lead Fournisseur', value: 'FOURNISSEUR_DE_LEAD' },
  { label: 'Appel Entant', value: 'TELEPHONE' },
  { label: 'Parrainage', value: 'PARRAINAGE' },
  { label: 'Téléprospection', value: 'RDV_DIRECT' },
  { label: 'Site Web', value: 'INTERNET' },
  { label: 'Apporteur', value: 'COURTIER' },
  { label: 'Multiequipement', value: 'MultiEquipement' }
];


export const typesProjets = [
{ label: 'Résidence principale', value: 'residence_principale' },
{ label: 'Résidence secondaire', value: 'residence_secondaire' },
{ label: 'Investissement locatif', value: 'investissement_locatif' },
{ label: 'Terrain', value: 'TER' },
{ label: 'Construction', value: 'CONST' },
{ label: 'Prêt professionnel', value: 'pret_professionnel' },
{ label: 'Prêt consommation', value: 'pret_consommation' }
];
export const garanties = [
  { label: 'Décès', formControl: 'quotiteDC' },
  { label: 'PTIA', formControl: 'quotitePTIA' },
  { label: 'ITT', formControl: 'quotiteITT' },
  { label: 'IPT', formControl: 'quotiteIPT' },
  { label: 'IPP', formControl: 'quotiteIPP' },
  { label: 'IPPRO', formControl: 'quotiteIPPRO' }
];

export const APRIL_PRODUCT_CODES = [
  "ADPv4",
  "ADPv5",
  "ADPAxxes",
  "ADPGenerali",
  "ADPFlex",
  "ADPOpportun",
  "ADPHorizon",
  "ADPAccess",
  "ADPIntegral"
];

export const formesJuridiques = [
  'EI', 'EIRL', 'SARL', 'SELARL', 'EURL', 'SAS', 'SASU', 'SA', 'SNC', 'SCA', 'SCI', 'SCS', 'Auto-entrepreneur', 'Commune', 'Association'
];

export const deplacementOptions = [
  { label: '< 15 000 km/an', value: 'moins15000' },
  { label: 'Entre 15 000 et 20 000 km/an', value: 'entre15000et20000' },
  { label: '> 20 000 km/an', value: 'plus20000' }
];

// Options pour le travail en hauteur
export const travailEnHauteurOptions = [
  { label: '< 3m', value: 'moins3m' },
  { label: 'Entre 3m et 15m', value: 'entre3et15m' },
  { label: '> 15m', value: 'plus15m' },
  { label: '> 20m', value: 'plus20m' }
];

// Pour le co-emprunteur aussi
export const coEmprunteurDeplacementOptions = [
  { label: '< 15 000 km/an', value: 'moins15000' },
  { label: 'Entre 15 000 et 20 000 km/an', value: 'entre15000et20000' },
  { label: '> 20 000 km/an', value: 'plus20000' }
];

// Options pour le travail en hauteur du co-emprunteur
export const coEmprunteurTravailEnHauteurOptions = [
  { label: '< 3m', value: 'moins3m' },
  { label: 'Entre 3m et 15m', value: 'entre3et15m' },
  { label: '> 15m', value: 'plus15m' },
  { label: '> 20m', value: 'plus20m' }
];


// Catégories professionnelles nécessitant la désactivation des champs professionnels
export const categoriesInactives = [
  'RETRAITE_CADRE',
  'RETRAITE_NONCADRE',
  'SANS_PROFESSION',
  'CHOMAGE'
];

export const professionalCategories = [
  { label: "— Non renseigné —", value: "" },
  { label: "Agent de maitrise / contremaître", value: "AGENT_MAITRISE" },
  { label: "Professions agricoles", value: "AGRICULTEUR" },
  { label: "Artisan", value: "ARTISAN" },
  { label: "Etudiant/ Intermittent / Saisonnier", value: "INTERMITTENT" },
  { label: "Sans profession", value: "SANS_PROFESSION" },
  { label: "Salarié Cadre/ Assimilé cadre / Ingénieur (hors personnel navigant)", value: "CADRE_ADMIN_COM" },
  { label: "Dirigeant de société/ Gérant/ Chef d'entreprise (de moins de 10 salariés) artisan/commerçant", value: "CHEF_ENTREPRISE_MOINS10_ARTISAN" },
  { label: "Dirigeant de société/ Gérant/ Chef d'entreprise (de moins de 10 salariés) hors artisan/commerçant", value: "CHEF_ENTREPRISE_MOINS10_HORS_ARTISAN" },
  { label: "Dirigeant de société/ Gérant/ Chef d'entreprise (de 10 salariés et plus)", value: "CHEF_ENTREPRISE_PLUS10" },
  { label: "Commerçant", value: "COMMERCANT" },
  { label: "Employé de bureau", value: "EMPLOYE_BUREAU" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant)", value: "EMPLOYE_HORS_BUREAU" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Autres professions médicales / paramédicales", value: "EMPLOYE_HORS_BUREAU_MEDICAL_AUTRES" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Chirurgiens, chirurgiens-dentistes", value: "EMPLOYE_HORS_BUREAU_MEDICAL_CHIRURGIEN" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "EMPLOYE_HORS_BUREAU_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Profession non médicale, non paramédicale", value: "EMPLOYE_HORS_BUREAU_MEDICAL_NON" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Ostéopathes", value: "EMPLOYE_HORS_BUREAU_MEDICAL_OSTEOPATHE" },
  { label: "Salarié non cadre (hors employé de bureau & personnel navigant) - Sages-femmes, kiné", value: "EMPLOYE_HORS_BUREAU_MEDICAL_PARAMEDICAL" },
  { label: "Profession intermédiaire de la santé et du travail social", value: "INTER_SANTE_SOCIAL" },
  { label: "Profession intermédiaire de la santé et du travail social - Autres professions médicales / paramédicales", value: "INTER_SANTE_SOCIAL_MEDICAL_AUTRES" },
  { label: "Profession intermédiaire de la santé et du travail social - Chirurgiens, chirurgiens-dentistes", value: "INTER_SANTE_SOCIAL_MEDICAL_CHIRURGIEN" },
  { label: "Profession intermédiaire de la santé et du travail social - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "INTER_SANTE_SOCIAL_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Profession intermédiaire de la santé et du travail social - Profession non médicale, non paramédicale", value: "INTER_SANTE_SOCIAL_MEDICAL_NON" },
  { label: "Profession intermédiaire de la santé et du travail social - Ostéopathes", value: "INTER_SANTE_SOCIAL_MEDICAL_OSTEOPATHE" },
  { label: "Profession intermédiaire de la santé et du travail social - Sages-femmes, kiné", value: "INTER_SANTE_SOCIAL_MEDICAL_PARAMEDICAL" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste", value: "LIBERAL_MEDICAL" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste - Autres professions médicales / paramédicales", value: "LIBERAL_MEDICAL_AUTRES" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste - Chirurgiens, chirurgiens-dentistes", value: "LIBERAL_MEDICAL_CHIRURGIEN" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "LIBERAL_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste - Ostéopathes", value: "LIBERAL_MEDICAL_OSTEOPATHE" },
  { label: "Profession libérale médicale ou paramédicale / Médecin (ou Interne) généraliste/ spécialiste - Sages-femmes, kiné", value: "LIBERAL_MEDICAL_PARAMEDICAL" },
  { label: "Profession libérale (hors médical/ paramédical)", value: "LIBERAL_NON_MEDICAL" },
  { label: "Ouvriers / Professions du Transport", value: "OUVRIER_TRANSPORT" },
  { label: "Hôtesse, steward, autre personnel navigant", value: "PERSONNEL_NAVIGANT" },
  { label: "Cadre navigant technique/commercial", value: "PERSONNEL_NAVIGANT_CHEF" },
  { label: "Retraité, Pré-retraité (Cadre/ Fonct. Classe A/ Chef d'Entreprise/ Prof. lib)", value: "RETRAITE_CADRE" },
  { label: "Retraité, Pré-retraité (non cadre)", value: "RETRAITE_NONCADRE" },
  { label: "Technicien", value: "TECHNICIEN" },
  { label: "Fonctionnaire de catégorie A (hors enseignement)", value: "FONCTIONNAIRE_A" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Autres professions médicales / paramédicales", value: "FCT_A_MEDICAL_AUTRES" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Chirurgiens, chirurgiens-dentistes", value: "FCT_A_MEDICAL_CHIRURGIEN" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "FCT_A_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Profession non médicale, non paramédicale", value: "FCT_A_MEDICAL_NON" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Ostéopathes", value: "FCT_A_MEDICAL_OSTEOPATHE" },
  { label: "Fonctionnaire de catégorie A (hors enseignement) - Sages-femmes, kiné", value: "FCT_A_MEDICAL_PARAMEDICAL" },
  { label: "Professeur agrégé", value: "FONCTIONNAIRE_A_PROF" },
  { label: "Fonctionnaire de catégorie B (hors enseignement)", value: "FONCTIONNAIRE_B" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Autres professions médicales / paramédicales", value: "FCT_B_MEDICAL_AUTRES" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Chirurgiens, chirurgiens-dentistes", value: "FCT_B_MEDICAL_CHIRURGIEN" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "FCT_B_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Profession non médicale, non paramédicale", value: "FCT_B_MEDICAL_NON" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Ostéopathes", value: "FCT_B_MEDICAL_OSTEOPATHE" },
  { label: "Fonctionnaire de catégorie B (hors enseignement) - Sages-femmes, kiné", value: "FCT_B_MEDICAL_PARAMEDICAL" },
  { label: "Instituteur, Professeur des écoles ou profession assimilée", value: "FONCTIONNAIRE_BC_INSTIT" },
  { label: "Professeur certifié ou profession assimilée", value: "FONCTIONNAIRE_BC_PROF" },
  { label: "Fonctionnaire de catégorie C (hors enseignement)", value: "FONCTIONNAIRE_C" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Autres professions médicales / paramédicales", value: "FCT_C_MEDICAL_AUTRES" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Chirurgiens, chirurgiens-dentistes", value: "FCT_C_MEDICAL_CHIRURGIEN" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Médecins, médecins spécialistes, interne, vétérinaires, pharmacien", value: "FCT_C_MEDICAL_MEDECIN_PHARMACIEN" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Profession non médicale, non paramédicale", value: "FCT_C_MEDICAL_NON" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Ostéopathes", value: "FCT_C_MEDICAL_OSTEOPATHE" },
  { label: "Fonctionnaire de catégorie C (hors enseignement) - Sages-femmes, kiné", value: "FCT_C_MEDICAL_PARAMEDICAL" },
  { label: "Chômage/en recherche d'emploi", value: "CHOMAGE" }
];
